import { CustomCell } from './components/custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';

export const TABLE_COLUMNS = () => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Компания',
			field: 'tk',
			flex: 1,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Название',
			field: 'name',
			flex: 2,
			filterOperators: getStringOperators(),
		},
	];
};

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
